import React, { Component } from 'react';
import moment from 'moment';
import PayixButton from '../../containers/payix-button';
import successImg from '../../assets/images/checked.png';

class CongratulationsModal extends Component {
  /**
   * Render the component view.
   */
  render() {
    let date = moment(this.props.date.date);
    
    return (
      <div>
        <div className="modal__header">
          <div className="modal__header-content--centered">
            <img src={ successImg } alt="" />

            <p className="modal-header-text">
              <span className="block gothammedium-font">Congratulations</span>
              <span className="op-08">Your payment has been scheduled</span>
            </p>
          </div>
        </div>
        
        <div className="modal__body">
          <div className="congratulations-modal__body">
            <div className="congratulations-modal__details">
              <div className="congratulations-modal__payment-details">
                <div>
                  <span className="money money--block money--green congratulations-modal__value">
                    {this.props.amountWithFee}
                  </span>
                  <span className="congratulations-modal__payment-frequency">
                    {this.props.frequency}
                  </span>
                </div>
                <div>
                  <p className="congratulations-modal__card-franchise">
                    {this.props.brand}
                  </p>
                  <span className="congratulations-modal__card-number">
                    **{this.props.lastFour}
                  </span>
                </div>
              </div>
              <div className="congratulations-modal__date-wrapper">
                <p className="congratulations-modal__date">
                  <span>DATE</span>
                  <br />
                  <b className="congratulations-modal__month">{date.format('MMM').toUpperCase()}</b>
                  <br />
                  <span>{date.date()}, {date.year()}</span>
                </p>
              </div>
            </div>

            <PayixButton className="button--full" onClick={ this.props.onClose }>
              CLOSE
            </PayixButton>
          </div>
        </div>
      </div>
    );
  }
}

export default CongratulationsModal;



// WEBPACK FOOTER //
// ./src/components/schedule/congratulations-modal.js